
/*
 * A singleton class used to load Google Maps library.
 * Provides a callback you can use in your client code, which depends on Google.
 *
 * @example
 *
 *   const googleMapsLoader = require('shared/javascripts/public_framework/services/google_maps_loader')
 *   googleMapsLoader.onReady(() => doSomething())
 *
 */

const SCRIPT_URL = [
  'https://maps.googleapis.com/maps/api/js?v=3.exp',
  `key=${gon.google_maps_api_browser_key}`,
  'libraries=places,geometry',
  'language=EN',
  'callback=googleMapsReadyCallback'
].join('&')

class GoogleMapsLoader {
  constructor () {
    this.scriptAppended = false
    this.scriptLoaded = false
    this.callbacks = []
  }

  appendScript () {
    window.googleMapsReadyCallback = this.handleScriptLoaded.bind(this)
    const script = document.createElement('script')
    script.src = SCRIPT_URL
    document.body.appendChild(script)
    this.scriptAppended = true
  }

  handleScriptLoaded () {
    this.scriptLoaded = true
    this.callbacks.forEach(callback => callback())
  }

  onReady (callback) {
    if (!this.scriptAppended) this.appendScript()
    if (this.scriptLoaded) {
      callback()
      return
    }
    this.callbacks.push(callback)
  }
}

const loader = new GoogleMapsLoader()

module.exports = loader



// WEBPACK FOOTER //
// ./front/apps/shared/javascripts/public_framework/services/google_maps_loader.js